const CLASE_AUSENCIA_OPTIONS = [
    { value: 0, text: 'Falta Injustificada', color: 'red' },
    { value: 1, text: 'Permisos sin Goce', color: 'orange' },
    { value: 2, text: 'Permisos con Goce', color: 'green' },
    { value: 3, text: 'Incapacidades', color: 'blue' },
    { value: 4, text: 'Vacaciones Disfrutadas', color: 'purple' }
];

export const getClaseAusenciaText = (value) => {
    const clase = CLASE_AUSENCIA_OPTIONS.find(c => c.value === value);
    return clase ? clase.text : '—';
};

export const getClaseAusenciaColor = (value) => {
    const clase = CLASE_AUSENCIA_OPTIONS.find(c => c.value === value);
    return clase ? clase.color : 'default';
};

export default CLASE_AUSENCIA_OPTIONS;
